import { WarningStep } from "#/components/carrot-card-cost-share/steps/variants/WarningStep"
import { Link } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths, Paths } from "#/utils/Paths"

export function AppearsToBeQualifiedMedicalExpenseStep(): JSX.Element {
  const intl = useIntl()
  return (
    <WarningStep
      title={intl.formatMessage({ defaultMessage: "This appears to be a qualified medical expense (QME). " })}
      primaryDescription={intl.formatMessage(
        {
          defaultMessage:
            "Your Carrot Card is not authorized for <link>QMEs</link> right now. Please use another payment method and submit a reimbursement request."
        },
        {
          link: (linkContent) => (
            <Link
              component={RouterLink}
              to={DbgPaths.QUALIFIED_MEDICAL_EXPENSES}
              color="inherit"
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkContent}
            </Link>
          )
        }
      )}
      secondaryDescription={intl.formatMessage({
        defaultMessage:
          "Your Care Team will email you soon with more information. You may need to take additional steps before using your Carrot Card for this type of expense. "
      })}
      tertiaryDescription={intl.formatMessage(
        {
          defaultMessage: "Please <link>contact us</link> if you think you're seeing this message in error."
        },
        {
          link: (linkContent) => (
            <Link component={RouterLink} to={Paths.CARE_TEAM} color="inherit" target="_blank" rel="noopener noreferrer">
              {linkContent}
            </Link>
          )
        }
      )}
    />
  )
}
